import { ReactElement } from 'react';
import {
  ModelSpecificBackgroundSt,
  ModelSpecificContainerSt,
  ModelSpecificDetailsGridSt,
  ModelSpecificDetailsContainerSt,
  ModelSpecificDetailsLabelSt,
  ModelSpecificDetailsTextSt,
  ModelSpecificImageContainerSt,
  ModelSpecificDetailsTitleSt,
  ModelSpecificDetailsContentSt,
  IconWrapperSt,
} from './ModelSpecificCTA.css';
import { Calendar, Car, Fuel } from '@heycar-uikit/icons';
import { MediaData } from 'app/shared/components/MediaGallery/utils';
import { MediaGallery } from 'app/shared/components/MediaGallery/MediaGallery';
import Translation from 'app/shared/components/Translation/Translation';

interface CTAProps {
  label: string;
  searchQueryParameters: string;
  fallbackSearchQueryParameters?: string;
}

export interface IModelSpecificCTAProps {
  launchYear: number;
  bodyType: string;
  fuelType: string;
  ctaButton: CTAProps;
  imageGallery: MediaData[];
}

const ModelSpecificCTA = ({
  launchYear,
  bodyType,
  fuelType,
  imageGallery,
}: IModelSpecificCTAProps): ReactElement => {
  return (
    <ModelSpecificContainerSt>
      <ModelSpecificBackgroundSt />
      <ModelSpecificImageContainerSt>
        <MediaGallery items={imageGallery} />
      </ModelSpecificImageContainerSt>
      <ModelSpecificDetailsContainerSt>
        <ModelSpecificDetailsTitleSt>
          <Translation
            id="shared.components.contentful.blocks.modelSpecificCTA.title"
            defaultMessage="heycar Review"
          />
        </ModelSpecificDetailsTitleSt>
        <ModelSpecificDetailsContentSt>
          <ModelSpecificDetailsGridSt>
            <ModelSpecificDetailsLabelSt>
              <IconWrapperSt>
                <Calendar />
              </IconWrapperSt>
              <Translation
                id="shared.components.contentful.blocks.modelSpecificCTA.launchYear"
                defaultMessage="Launch Year"
              />
            </ModelSpecificDetailsLabelSt>
            <ModelSpecificDetailsTextSt>
              {launchYear}
            </ModelSpecificDetailsTextSt>
            <ModelSpecificDetailsLabelSt>
              <IconWrapperSt>
                <Car />
              </IconWrapperSt>
              <Translation
                id="shared.components.contentful.blocks.modelSpecificCTA.bodyType"
                defaultMessage="Body Type"
              />
            </ModelSpecificDetailsLabelSt>
            <ModelSpecificDetailsTextSt>{bodyType}</ModelSpecificDetailsTextSt>
          </ModelSpecificDetailsGridSt>
          <ModelSpecificDetailsGridSt>
            <ModelSpecificDetailsLabelSt>
              <IconWrapperSt>
                <Fuel />
              </IconWrapperSt>
              <Translation
                id="shared.components.contentful.blocks.modelSpecificCTA.fuelType"
                defaultMessage="Fuel Type"
              />
            </ModelSpecificDetailsLabelSt>
            <ModelSpecificDetailsTextSt>{fuelType}</ModelSpecificDetailsTextSt>
          </ModelSpecificDetailsGridSt>
        </ModelSpecificDetailsContentSt>
      </ModelSpecificDetailsContainerSt>
    </ModelSpecificContainerSt>
  );
};

export default ModelSpecificCTA;
